<template>
  <b-field
    :label="label"
    :type="hasError() ? 'is-danger' : ''"
    :message="errorMessage()"
    :class="{ required: required }"
  >
    <template v-if="hasInfo" #label>
      {{ label }}
      <span>
        <b-tooltip
          type="is-light"
          :size="infoSize"
          :position="infoPosition"
          multilined
        >
          <i :class="infoIcon" />
          <template #content>
            <p v-if="infoType == 'text'">{{ info }}</p>
            <slot v-if="infoType == 'html'" name="info">
              <div v-html="info" />
            </slot>
          </template>
        </b-tooltip>
      </span>
    </template>
    <v-autocomplete-fetch
      ref="autocompleteFetch"
      :value="value"
      :route="route"
      :field="field"
      :icon="icon"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :open-on-focus="openOnFocus"
      :keep-first="keepFirst"
      :disabled="disabled"
      :required="required"
      :parameters="parameters"
      :append-to-body="appendToBody"
      @typing="$emit('typing', $event)"
      @input="onInput"
    >
      <template slot="selection" slot-scope="scope">
        <slot v-bind="scope" name="selection" />
      </template>
      <template slot="default" slot-scope="scope">
        <slot v-bind="scope" name="default" />
      </template>
      <template v-if="hasAction" slot="footer" slot-scope="scope">
        <slot v-bind="scope" name="action" />
      </template>
    </v-autocomplete-fetch>
  </b-field>
</template>

<script>
import InputBase from "./InputBase";
import AutocompleteFetchVue from "../components/AutocompleteFetch.vue";

export default {
  components: {
    "v-autocomplete-fetch": AutocompleteFetchVue,
  },
  extends: InputBase,
  props: {
    value: {
      default: null,
      validator(value) {
        return _.isString(value) || _.isObject(value);
      },
    },
    route: {
      required: true,
      type: String,
    },
    field: {
      default: undefined,
      type: String,
    },
    icon: {
      default: "magnify",
      type: String,
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
    openOnFocus: {
      type: Boolean,
      default: false,
    },
    keepFirst: {
      type: Boolean,
      default: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    parameters: {
      default() {
        return {};
      },
      type: Object,
    },
    hasInfo: {
      default: false,
      type: Boolean,
    },
    infoIcon: {
      default: "mdi mdi-information-outline",
      type: String,
    },
    info: {
      default: "",
      type: String,
    },
    infoPosition: {
      default: "is-top",
      type: String,
    },
    infoSize: {
      default: "is-medium",
      type: String,
    },
    infoType: {
      default: "text",
      type: String,
    },
    hasAction: {
      default: false,
      type: Boolean,
    },
    appendToBody: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      query: "",
      page: 0,
      stopScroll: false,
      data: [],
      isFetching: false,
    };
  },
  methods: {
    onInput(event) {
      this.inputListener(event);
    },
  },
};
</script>
